import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils/"

import { NotAllowedBlock } from "@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


export default function listPriceColumn() {
	return {
		name: "listPrice",
		label: `List Price (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageListPrice"], { decimals: 2 })})`,
		options: {
			display: false,
			filter: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			customBodyRowRender: (value, { currency }) => value ? `${value} ${currency}` : <NotAllowedBlock />
		}
	}
}